import { render } from "./DashboardOwners.vue?vue&type=template&id=814655f6"
import script from "./DashboardOwners.vue?vue&type=script&lang=js"
export * from "./DashboardOwners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__